/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AdminStatuses {
    PENDING = 'Pending',
    ACCEPTED = 'Accepted',
    REJECTED = 'Rejected',
    DELETED = 'Deleted',
}